import { IMN_LIGHT_THEME } from './light.mjs';
import { IMN_DARK_THEME } from './dark.mjs';
export const IMN_THEME={light: IMN_LIGHT_THEME, dark: IMN_DARK_THEME};
